<template>
    <div>
        <div :style="{top:popupShow?0:'-748px'}" class="popup">
            <div class="popup_top">
                <div>
                    <img src="../../static/layout/logo.png" alt="">
                    <span> 到家旅居</span>
                </div>
            </div>
            <div class="popup_qrcode">
                <div>
                    <h2>微信小程序预订</h2>
                    <h6>到家微信小程序，为您提供在线预订与搜索服务</h6>
                </div>
                <div class="popup_qrcode_img">
                    <img src="../../static/layout/mpWeixin.jpg" alt="">
                    <div>使用微信扫码</div>
                </div>
            </div>
            <div class="popup_btn" @click="popupShow=false">收起</div>
        </div>
        <div class="index_header">
            <img src="../../static/index/1.png" alt="#">
            <a
                class="share_ai_link"
                href="https://shareai.daojia.zone/login"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="榭尔AI"
            >
                <img src="../../static/index/xieer-ai.png" alt="榭尔AI">
            </a>
        </div>
        <div class="index_goMp_img" @click="popupShow=true">
            <img src="../../static/index/2.png" alt="#">
        </div>
        <!-- 盒子 -->
        <div class="index_house">
            <h2>到家旅居优质房源</h2>
            <h6>每一个家，为您严格审核。更有设计师精心设计特色民宿，带给你不一样的体验</h6>
            <div class="house_list">
                <img @click="popupShow=true" v-for="(item, index) in houseList" :key="index" :src="item" alt="#">
            </div>
            <div @click="popupShow=true" class="goMp_text">
                前往小程序预订》
            </div>
        </div>
        <div class="index_1">
            <img src="../../static/index/4.png" alt="#">
        </div>
        <div class="index_2">
            <img src="../../static/index/5.png" alt="#">
        </div>
        <div class="index_3">
            <img src="../../static/index/6.png" alt="#">
        </div>
        <div class="index_4">
            <img src="../../static/index/7.png" alt="#">
        </div>
        <div class="index_5">
            <img src="../../static/index/8.png" alt="#">
        </div>
        <div class="index_6">
            <img src="../../static/index/9.png" alt="#">
        </div>
        <div class="index_7">
            <img src="../../static/index/10.png" alt="#">
        </div>



    </div>
</template>
<script>
export default {
    name: 'Index',
    data() {
        return {
            popupShow:false,
            houseList: [
                require('../../static/index/house/2.1.png'),
                require('../../static/index/house/2.2.png'),
                require('../../static/index/house/2.3.png'),
                require('../../static/index/house/2.4.png'),
                require('../../static/index/house/2.5.png'),
                require('../../static/index/house/2.6.png'),
                require('../../static/index/house/2.7.png'),
                require('../../static/index/house/2.8.png'),
                require('../../static/index/house/2.9.png'),
                require('../../static/index/house/2.10.png'),
                require('../../static/index/house/2.11.png'),
                require('../../static/index/house/2.12.png'),
            ],

        }
    },
    methods: {},
    mounted() {

    },
    computed: {
        //计算高度
        // computeHeight() {
        //     let screenHeight = document.body.clientWidth;
        //     if (screenHeight > 415) {
        //         return '550px';
        //     } else {
        //         return '250px';
        //     }
        // },
        // computeArrowImg() {
        //     let screenHeight = document.body.clientWidth;
        //     if (screenHeight > 450) {
        //         return require('../../static/other/arrow.png');
        //     } else {
        //         return require('../../static/other/arrow_down.png');
        //     }
        // }

    },
}
</script>

<style scoped>
.index_header {
    width: 100%;
    position: relative;
    line-height: 0;
}
.index_header > img{
    width: 100%;
    display: block;
}

.share_ai_link {
    position: absolute;
    top: 3.6574074074%;
    left: 16.5885416667%;
    width: 4.7135416667%;
    display: block;
    cursor: pointer;
    z-index: 2;
}

.share_ai_link img {
    width: 100%;
    display: block;
}

.index_goMp_img {
    margin: auto;
    margin-top: -80px;
    text-align: center;
    cursor: pointer;
    position: relative;
    z-index: 3;
}

.index_house {
    width: 1120px;
    margin: auto;
    text-align: center;
}

.index_house h2 {

    font-size: 44px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 62px;
    margin-top: 88px;
    margin-bottom: 27px;
}

.index_house h6 {
    margin-bottom: 70px;
    font-size: 16px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 22px;
}

.house_list {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}

.house_list img {
    width: 274px;
    height: 498px;
    margin-bottom: 30px;
    cursor: pointer;
}

.goMp_text {
    margin: 40px auto 100px auto;

    font-size: 22px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #1A1A1A;
    line-height: 30px;
    text-decoration: underline;
    cursor: pointer;

}
.index_1 {
    width: 100%;
   
}
.index_1 img{
    width: 100%;
}
.index_2{
    padding-top: 60px;
    width: 100%;
    padding-bottom: 98px;
    
    display: flex;
    justify-content: center;
    align-items: center;
}
.index_2 img{
    width: 1106px;
    height: 678px;
   
}
.index_3 {
    width: 100%;
   
}
.index_3 img{
    width: 100%;
}
.index_4{
    padding-top: 98px;
    width: 100%;
    padding-bottom: 98px;
    
    display: flex;
    justify-content: center;
    align-items: center;
}
.index_4 img{
    width: 1320px;
    height: 423px;
   
}
.index_5 {
    width: 100%;
   
}
.index_5 img{
    width: 100%;
}
.index_6{
    padding-top: 98px;
    width: 100%;
    padding-bottom: 98px;
    
    display: flex;
    justify-content: center;
    align-items: center;
}
.index_6 img{
    width: 1120px;
    height: 659px;
   
}

.index_7 {
    width: 100%;
   
}
.index_7 img{
    width: 100%;
}
.popup {
    position: fixed;
    width: 100%;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.1);
    background: #FFFFFF;
    padding: 0 0 39px 0;
    z-index: 10;
    top: -748px;
    height: 748px;
    overflow: hidden;
    transition: .5s;
}

.popup_top {
    padding-left: 400px;
    border-bottom: 1px #E0E0E0 solid;
}

.popup_top div {
    width: 177px;
    height: 87px;
    background: #242931;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 25px;
}

.popup_top div img {
    width: 34px;
    height: 28px;
    margin-right: 9px;
}

.popup_qrcode {
    display: flex;
    align-items: center;
    padding-top: 194px;
    padding-bottom: 106px;
   justify-content: center;
}

.popup_qrcode h2 {
    font-size: 50px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 70px;

}

.popup_qrcode h6 {
    width: 464px;
    font-size: 26px;
    color: #333333;
    line-height: 37px;
    margin-right: 134px;
}
.popup_qrcode_img{
font-size: 18px;
color: #999999;
line-height: 25px;
text-align: center;
}
.popup_qrcode_img img {
    width: 240px;
height: 240px;
margin-bottom: 2px;
}
.popup_btn{
    width: 148px;
height: 54px;
background: #FFFFFF;
border-radius: 8px;
border: 1px solid rgba(205,205,205,0.5);
text-align: center;
line-height: 54px;
font-size: 20px;

color: #1A1A1A;
margin: auto;
cursor: pointer;

}

@media screen and (max-width: 768px) {
    .share_ai_link {
        top: 3.6574074074%;
        left: 16.5885416667%;
        width: 4.7135416667%;
    }
}
</style>
